import { apiFetch } from './client';

export interface RegisterChannelOption {
  id: string;
  name: string;
  alias: string;
  order: string;
}

export function getRegisterChannel(): Promise<RegisterChannelOption[]> {
  return apiFetch<RegisterChannelOption[]>('/api/v1/porters/register-channel');
}
